<div *ngIf="auction" provide-parent-form>
	<div class="field-group">
		<bb-prebid-fields mode="card" typeFilter="adapter" *ngIf="auction?.prebidConfiguration && hasAvailableSystems" [prebidParams]="auction?.prebidConfiguration" [filterParams]="prebidService.publicationPrebidParams" (change)="prebidParamsChanged()"></bb-prebid-fields>
		<div class="info message" *ngIf="hasAvailableSystems === false" [innerHtml]="'INFO.AUCTION_PREBID_NO_ENABLED_ADAPTERS' | translate"></div>
	</div>
</div>
